import React from "react";
import isActiveSale from "../isActiveSale";
import SaleBadgeAndPricing from "~/common/SaleBadgeAndPricing";
import StandardPrice from "../StandardPrice";
import { PricingProduct } from "../PricingProduct";

const SalePricing = (props: {
  price: PricingProduct["price"];
  unitOfMeasure: string;
}) => {
  const { price, unitOfMeasure } = props;
  return (
    <>
      {isActiveSale(price) && (
        <SaleBadgeAndPricing
          dataTestId="itemSale"
          price={price.price}
          salePricingClassNames="p-0 my-1 text-sm text-gray-800 font-normal"
          saleBadgeExtraClassNames="px-1 mr-1 py-0.5"
        />
      )}
      <StandardPrice
        price={isActiveSale(price) ? price.salePrice : price.price}
        unitOfMeasure={unitOfMeasure}
      />
    </>
  );
};

export default SalePricing;
